import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Label from 'shared/components/label';
import Dropdown from 'src/components/dropdown';
import {setFromTargetValue} from 'src/utils/form';
import {sortBy} from 'lodash';

const propTypes = {
  disabled: PropTypes.bool,
  educationPhase: PropTypes.string,
  sponsorId: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  fetchScholarshipPrograms: PropTypes.func,
  autoSelectFirstProgram: PropTypes.bool,
};

const ScholarshipProgramDropdown = (props) => {
  const [scholarshipPrograms, setScholarshipPrograms] = useState([]);
  const {educationPhase, sponsorId, value, onChange, fetchScholarshipPrograms, disabled} = props;
  const scholarshipProgramOptions = scholarshipPrograms.map(({_id, name}) => ({
    _id,
    value: _id,
    text: name,
  }));

  useEffect(() => {
    if (sponsorId) {
      fetchScholarshipPrograms(educationPhase, sponsorId).then((responseScholarshipPrograms) => {
        setScholarshipPrograms(sortBy(responseScholarshipPrograms, ['name']));
      });
    }
  }, [sponsorId, educationPhase]);

  useEffect(() => {
    if (props.autoSelectFirstProgram && scholarshipProgramOptions.length > 0) {
      onChange(scholarshipProgramOptions[0].value);
    }
  }, [props.autoSelectFirstProgram, scholarshipProgramOptions.length]);

  return (
    <Label>
      Scholarship Program
      <Dropdown
        name="scholarshipProgramId"
        onChange={setFromTargetValue(onChange)}
        options={scholarshipProgramOptions}
        value={value}
        disabled={disabled}
        cy="scholarship-program-dropdown"
        testid="scholarship-program-dropdown"
      />
    </Label>
  );
};

ScholarshipProgramDropdown.propTypes = propTypes;

export default ScholarshipProgramDropdown;
